import { useCallback, useEffect, useState } from 'react';
import { getTransactionFilterOptions } from '../utils/transactionDataApi';
let inFlightFilters;
let cachedFilters;

const fetchFilters = () => {
  if (cachedFilters) return Promise.resolve(cachedFilters);
  if (!inFlightFilters) {
    inFlightFilters = getTransactionFilterOptions()
      .then((response) => {
        if (!response || response.status >= 400) throw new Error('Unable to load transaction filters');
        cachedFilters = {
          suppliers: response?.data?.suppliers || [],
          customers: response?.data?.customers || [],
        };
        return cachedFilters;
      })
      .finally(() => {
        inFlightFilters = null;
      });
  }
  return inFlightFilters;
};

export const useTransactionResources = ({ preloadFilters = true } = {}) => {
  const [filters, setFilters] = useState(cachedFilters || { suppliers: [], customers: [] });
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [error, setError] = useState('');

  const loadFilters = useCallback(async () => {
    if (cachedFilters) return cachedFilters;
    setFiltersLoading(true);
    setError('');
    try {
      const data = await fetchFilters();
      setFilters(data);
      return data;
    } catch (requestError) {
      setError('Unable to load transaction filters');
      throw requestError;
    } finally {
      setFiltersLoading(false);
    }
  }, []);

  useEffect(() => {
    if (preloadFilters) loadFilters().catch(() => {});
  }, [loadFilters, preloadFilters]);

  return { ...filters, filtersLoading, filtersLoaded: Boolean(cachedFilters), loadFilters, error };
};

export const __resetTransactionResourcesForTests = () => {
  inFlightFilters = null;
  cachedFilters = undefined;
};
